import React from 'react'

import GridItem from './GridItem'
import GridListHeaderComp from './GridListHeaderComp'
import { Container, GridContainer } from './styled-components'

export type GridProps = {
  className?: string
  onItemPress?: (item: any) => void
  selectedIndex?: number | null
  isHeaderBelowGraph?: boolean
  mobilePadding?: number
  hasBorder?: boolean
  hasHeader?: boolean
  hasPercentage?: boolean
  items: any[]
  testIdPrefix: string
  itemType?: string
  title?: string
}

const Grid = (props: GridProps) => (
  <Container hasBorder={props.hasBorder} className={props.className}>
    {props.hasHeader && (
      <GridListHeaderComp
        itemCount={props.items.length}
        itemType={props.itemType}
        title={props.title}
      />
    )}
    <GridContainer
      isHeaderBelowGraph={props.isHeaderBelowGraph}
      mobilePadding={props.mobilePadding}
    >
      {props.items.map((item, index) => {
        const isDisabled =
          props.selectedIndex !== null ? props.selectedIndex !== index : false

        return (
          <GridItem
            item={item}
            key={item.symbol}
            onPress={props.onItemPress}
            disabled={isDisabled}
            hasPercentage={props.hasPercentage}
            testIdPrefix={props.testIdPrefix}
          />
        )
      })}
    </GridContainer>
  </Container>
)

export default Grid
